import moment from "moment";

const CATEGORY_TYPES = {
  JOB: "JOB",
  CANDIDATE: "CANDIDATE",
  TELEPHONIC_SCREENING: "TELEPHONIC_SCREENING",
  AI_ASSESSMENTS: "AI_ASSESSMENTS",
  VIDEO_INTERVIEW: "VIDEO_INTERVIEW",
};

const CATEGORY_MAP = {
  "57c9494a-61bf-4e13-aac9-c394a96e30ae": CATEGORY_TYPES.JOB,
  "6c32c210-292d-454a-9568-e2fef721e1a9": CATEGORY_TYPES.CANDIDATE,
  "6ab896ce-71ef-4a23-a805-6d0fe8251153": CATEGORY_TYPES.TELEPHONIC_SCREENING,
  "1e76d23b-6715-4a8a-8bac-c40ba1c5a78c": CATEGORY_TYPES.AI_ASSESSMENTS,
  "73397da6-063f-4937-b364-e77455c2e51b": CATEGORY_TYPES.VIDEO_INTERVIEW,
};

// Map backend event_type_id to semantic event keys
const EVENT_ID_MAP = {
  "f643992b-fb71-4ecf-870c-c5a0cfbd22e3": "assigned",
  "fa5e05d6-afb8-4aab-88b4-626884b789a1": "created",
  "fb83d095-722c-4427-a710-cb05fad7a8df": "published",
  "a4d1c9e0-e0d3-4279-8c84-d7788c7ad8cd": "scheduled",
  "553ffe86-0bd6-4bd4-85a7-548f48117c50": "engaged",
  "24c1a279-265a-4422-933c-f7eae8decae9": "not_scheduled",
  "5571d3a4-d5a0-4b69-bf03-2d6bba059d27": "ongoing",
  "b9d012f8-505d-4c05-9977-60f75f829e99": "failed",
  "925f880e-ebd7-4b6a-af57-2eb5e950fc83": "completed",
};

const EVENT_MESSAGES = {
  created: {
    JOB: "New Job - {job} has been created successfully by {createdby}.",
    CANDIDATE: "{candidate} has been added to {job}.",
  },
  published: {
    JOB: "{job} has been published by {createdby}",
    CANDIDATE: "{candidate} has been added to {job}.",
  },
  assigned: {
    TELEPHONIC_SCREENING:
      "{stage} assigned to {candidate} for {job}.",
    AI_ASSESSMENTS: "{stage} assigned to {candidate} for {job}.",
    VIDEO_INTERVIEW: "{stage} assigned to {candidate} for {job}.",
  },
  scheduled: {
    TELEPHONIC_SCREENING:
      "{stage} scheduled for {candidate} for job {job} on {date}.",
    AI_ASSESSMENTS: "{stage} scheduled for {candidate} for job {job} on {date}.",
    VIDEO_INTERVIEW: "{stage} scheduled for {candidate} for job {job} on {date}.",
  },
  ongoing: {
    TELEPHONIC_SCREENING:
      "{stage} started for {candidate} in job {job}.",
      AI_ASSESSMENTS: "{stage} started for {candidate} in job {job}.",
      VIDEO_INTERVIEW: "{stage} started for {candidate} in job {job}.",
  },
  failed: {
    TELEPHONIC_SCREENING:
      "{stage} could not be completed for {candidate} in job {job}.",
    AI_ASSESSMENTS: "{stage} could not be completed for {candidate} in job {job}.",
    VIDEO_INTERVIEW: "{stage} could not be completed for {candidate} in job {job}.",
  },
  completed: {
    TELEPHONIC_SCREENING:
      "{candidate} completed the {stage} for job {job}.",
      AI_ASSESSMENTS: "{candidate} completed the {stage} for job {job}.",
      VIDEO_INTERVIEW: "{candidate} completed the {stage} for job {job}.",
  }
};

const STYLE_MAP = {
  [CATEGORY_TYPES.TELEPHONIC_SCREENING]: {
    icon: "/images/circle-phone.svg",
    bg: "#0048B7",
    fromTab: "voice",
  },
  [CATEGORY_TYPES.AI_ASSESSMENTS]: {
    icon: "/images/user-check.svg",
    bg: "#FF1C58",
    fromTab: "assessment",
  },
  [CATEGORY_TYPES.VIDEO_INTERVIEW]: {
    icon: "/images/video-icon.svg",
    bg: "#00DDFF",
    fromTab: "video",
  },
  [CATEGORY_TYPES.JOB]: {
    icon: "/images/bag-icon.svg",
    bg: "#F5A623",
  },
  [CATEGORY_TYPES.CANDIDATE]: {
    icon: "/images/user-plus.svg",
    bg: "#FFC857",
  },
};

export const formatNotification = (notification) => {
  const { id, created_at, meta_data } = notification || {};
  const {
    job_id,
    candidate_id,
    category,
    event_type,
    data,
  } = meta_data || {};

  const categoryKey = CATEGORY_MAP[category] || CATEGORY_TYPES.JOB;
  const eventKey = EVENT_ID_MAP[event_type];
  const job = data?.job;
  const candidate = data?.candidate;
  const stage = data?.stage;
  const date = data?.stage?.scheduled_on ? moment(data.scheduled_on).format("DD MMM YYYY") : "";
  const createdby = data?.job?.created_by?.name || data?.job?.updated_by?.name;

  
  const style = STYLE_MAP[categoryKey] || {};
  const timeAgo = moment(created_at).fromNow();
  
  let message = "You have a new notification";
  const template = EVENT_MESSAGES?.[eventKey]?.[categoryKey];
  if (template) {
    message = template
    .replace("{job}", job?.title || "")
    .replace("{candidate}", candidate?.name || "")
    .replace("{stage}", stage?.name || "")
    .replace("{date}", date || "")
    .replace("{createdby}", createdby || "")
  }
  
  let to = `/jobs/${job_id}/candidates`;
  let navState = undefined;
  if (categoryKey === CATEGORY_TYPES.CANDIDATE) {
    to = `/jobs/${job_id}/candidates`;
  }
  if (
    [CATEGORY_TYPES.TELEPHONIC_SCREENING, CATEGORY_TYPES.AI_ASSESSMENTS, CATEGORY_TYPES.VIDEO_INTERVIEW].includes(categoryKey)
  ) {
    to = `/jobs/${job_id}/candidates/${candidate_id}`;
    navState = { fromTab: style.fromTab };
  }
  
  return {
    id,
    timeAgo,
    message,
    icon: style.icon,
    bgColor: style.bg,
    to,
    navState,
  };
};
